import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getEndpoint } from "./basics";
const base = getEndpoint();

export const llmApi = createApi({
	reducerPath: "llmApi",
	baseQuery: fetchBaseQuery({
		baseUrl: base,
		prepareHeaders: (headers) => {
			headers.set("Content-Type", "application/json");
			headers.set("Accept", "application/json");
			return headers;
		},
		credentials: "include"
	}),
	tagTypes: [],
	endpoints: (builder)  => ({
		getWorkplaceRAGDocuments: builder.query({
			query: (id) => ({
				url: `llm/workplace/${id}/documents`,
				method: "GET"
			})
		}),
		getSingleWorkplaceRAGDocument: builder.query({
			query: (workplaceId, documentId) => ({
				url: `llm/workplace/${workplaceId}/documents/${documentId}`,
				method: "GET"
			})
		}),
		createRAGDocument: builder.mutation({
			query: ({workplaceId, name}) => ({
				url: `llm/workplace/${workplaceId}/document`,
				method: "POST",
				body: {
					name
				}
			})
		}),
		getRAGDocumentUploadConfig: builder.query({
			query: ({workplaceId, documentId}) => ({
				url: `llm/workplace/${workplaceId}/document/${documentId}/getUploadUrl`,
				method: "GET"
			})
		}),
		updateRAGDocument: builder.mutation({
			query: ({workplaceId, documentId, fileId}) => ({
				url: `llm/workplace/${workplaceId}/document/${documentId}`,
				method: "PATCH",
				body: {
					fileId
				}
			})
		}),
		ingestRAGDocument: builder.mutation({
			query: ({workplaceId, documentId}) => ({
				url: `llm/workplace/${workplaceId}/document/ingest/${documentId}`,
				method: "POST"
			})
		})
	})
})

export const {
	useGetWorkplaceRAGDocumentsQuery,
	useGetSingleWorkplaceRAGDocumentQuery,
	useCreateRAGDocumentMutation,
	useGetRAGDocumentUploadConfigQuery,
	useUpdateRAGDocumentMutation,
	useIngestRAGDocumentMutation,
} = llmApi;